import { connect } from 'react-redux'
import { actions } from 'appRedux/modules/Order'
import { actions as actionsUserCards } from 'appRedux/modules/UserCards'
import { TapPayForm as component } from './TapPayForm'


const mapStateToProps = (state, ownProps) => ({
    // props for checkout
	can_bind_card: state.UserCards.can_bind_card,
    // props for update

    colour_theme: state.ColourTheme.colour_theme,
});
const mapDispatchToProps = (dispatch, ownProps) => ({
	onBindCardSet: (canBind) => dispatch(actionsUserCards.setBindCard(canBind)),
    onTapPayCanGetPrime: (canGet) => dispatch(actions.canGetTapPayPrime(canGet)),
});
const TapPayForm = connect(mapStateToProps, mapDispatchToProps)(component);


export { TapPayForm }
